import { mapActions } from 'vuex';


export default {
    props: {
        filterId: {
            type: String,
        },
    },
    methods: {
        ...mapActions(['setFormFilter']),
        updateVal() {
            if (!this.filterId) {
                return;
            }

            this.setFormFilter({
                id: this.filterId,
                val: this.field.val,
            });
        },
    },
    watch: {
        field: {
            handler() {
                if (!this.filterId) {
                    return;
                }

                this.updateVal();
            },
            immediate: true,
            deep: true,
        },
    },
    beforeDestroy() {
        if (!this.filterId) {
            return;
        }

        this.setFormFilter({
            id: this.filterId,
            val: '',
        });
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/components/cms-plugins/sib-form/form-field-filter/filter-master-mixin.js